import React, { useState, useEffect } from 'react';
import { NotificationForPatient, NotificationForDoctor } from '../services/notification';
import useNotificationStore from '../../zustand/notification';
const NotificationsDropdown = ({ user }) => {
     const {  decrementCount} = useNotificationStore()
    const [currentPage, setCurrentPage] = useState(1);
    const [allNotifications, setNotifications] = useState([]);
    const [notificationCount, setNotificationCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const limit = 4;
    const totalPages = Math.ceil(notificationCount / limit);

    const fetchNotifications = async (page = 1) => {
    
        setLoading(true);
     
        try {
            let res;

            if (Number(user?.usertype) === 1) {
                res = await NotificationForPatient.patientNotificationList(page, limit);
            } else if (Number(user?.usertype) === 2) {
                res = await NotificationForDoctor.doctorNotificationList(page, limit);
            }

            if (res?.data) {
                setNotifications(res.data.data); 
                setNotificationCount(res.data.total); 
            }
        } catch (error) {
            console.error('Error fetching notifications:', error?.message);
        } finally {
         
            setLoading(false);
         
          
        }
    };

    const handleNotificationClick = async (id) => {
        try {
            if (user?.usertype === 1) {
                await NotificationForPatient.isReadNotificationPatient(id);
            } else if (user?.usertype === 2) {
                await NotificationForDoctor.isReadNotificationDoctor(id);
            }
            decrementCount()
            fetchNotifications(currentPage); 
        } catch (error) {
            console.error('Error marking notification as read:', error);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    useEffect(() => {
        if (user?.usertype) {
            fetchNotifications(currentPage);
        }
    }, [user, currentPage]);

    return (
        <div className="p-6 rounded border border-gray-300 bg-white items-center">
            <h2 className="text-lg font-bold  text-center">Notifications</h2>

            <div className="w-full relative min-h-[200px]">
                {allNotifications.length === 0 && !loading ? (
                    <div className="py-8 text-gray-500 text-center">No notifications found.</div>
                ) : (
                    allNotifications.map((n) => (
                        <div  
                            key={n.id}
                            className={`py-4 px-5 border-b cursor-pointer hover:bg-gray-100 ${
                                n.isRead ? 'text-gray-500' : 'font-semibold'
                            }`}
                            onClick={() => handleNotificationClick(n.id)}
                        >
                            <div>{n.title}</div>
                            <div className="text-base text-gray-600">{n.content}</div>
                        </div>
                    ))
                )}

                {/* Loader overlay */}
                {loading && (
                    <div className="absolute inset-0 bg-white bg-opacity-60 flex justify-center items-center z-10">
                        <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-blue-500 border-solid"></div>
                    </div>
                )}
            </div>

            {notificationCount > 0 && (
                <div className="flex justify-center items-center mt-4 w-full">
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className={`mx-2 px-3 py-1 rounded ${
                            currentPage === 1 ? 'text-gray-400 cursor-not-allowed' : 'text-blue-500'
                        }`}
                    >
                        Prev
                    </button>
                    <span className="text-sm text-gray-700">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className={`mx-2 px-3 py-1 rounded ${
                            currentPage === totalPages ? 'text-gray-400 cursor-not-allowed' : 'text-blue-500'
                        }`}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default NotificationsDropdown;
